const Popup = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer2"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="8"
      d="M20 26V8h42v32H44"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
    <path
      data-name="layer1"
      fill="none"
      stroke={color}
      strokeMiterlimit="10"
      strokeWidth="8"
      d="M2 26h42v32H2z"
      strokeLinejoin="round"
      strokeLinecap="round"
    ></path>
  </svg>
);

export default Popup;
